import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hackerrank': {
    width: 464,
    height: 512,
    paths: [
      {
        d: 'M453.5 128C439 103.1 261.1 0 232.2 0 203.2 0 25.3 102.8 10.8 128-3.6 153.2-3.6 358.8 10.8 384 25.3 409.2 203.2 512 232.2 512S439 409.1 453.5 384C468 358.9 468 152.9 453.5 128zM292.1 414.2C288.2 414.2 251.2 378.4 254.1 375.5 255 374.7 260.4 374.1 271.7 373.7 271.7 347.5 272.3 305.1 272.6 287.4 272.7 285.4 272.2 283.9 272.2 281.5H192.3C192.3 288.6 191.8 317.7 193.6 354.4 193.8 358.9 192 360.4 187.9 360.4 177.8 360.3 167.6 360.2 157.5 360.3 153.4 360.3 151.6 358.7 151.7 354.2 152.7 320.7 154.7 270.1 151.6 141.5V138.3C141.9 138 135.2 137.4 134.3 136.5 131.4 133.6 168.9 97.8 172.8 97.8 176.8 97.8 214 133.6 211.1 136.5 210.2 137.4 203.2 138 194.3 138.3V141.5C191.9 167.2 192.3 221.1 191.7 246.9H271.9C271.9 242.3 272.3 212.1 270.7 163.2 270.6 159.8 271.7 158.1 274.9 158 286 157.9 297.1 157.9 308.2 158 311.6 158 312.8 159.7 312.7 163.4 309 354.6 312 341.3 312 373.7 320.9 374 328.8 374.6 329.7 375.5 332.6 378.4 296.1 414.2 292.1 414.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hackerrank.js
// module id = CusF
// module chunks = 144